import { headerSelectors } from 'redux/Header/header.selectors'
import { Redux } from 'types/local'
import { ApolloClient, ApolloError, InMemoryCache } from '@apollo/client'

const createApolloClient = () => {
  return new ApolloClient({
    uri: 'https://api.thegraph.com/subgraphs/name/tdkhoa2002/megaproject',
    cache: new InMemoryCache(),
  })
}

export default createApolloClient

export const createGraphqlApiHandler = (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  const isAuthenticated = headerSelectors.isAuthenticated(getState())
  const request =
    (isRetrying = false) =>
    async <T>(createRequest: (authHeaders: any) => Promise<T>): Promise<T> => {
      const state = getState()
      const authHeaders = headerSelectors.getAuthHeaders(state)
      if (!isAuthenticated) {
        return createRequest(authHeaders)
      }
      try {
        return await createRequest(authHeaders)
      } catch (error) {
        const { graphQLErrors } = error as ApolloError
        if (graphQLErrors) {
          if (graphQLErrors.some((el) => el.extensions.code === 'UNAUTHENTICATED' && !isRetrying)) {
            return new Promise<any>((resolve, reject) => {
              resolve(request(true)(createRequest))
            })
          }
        }
        console.log('error', error)
        throw error
      }
    }
  return request(false)
}
